module.exports = __webpack_public_path__ + "img/LOGO-01.142a1e2f.png";